module.exports = __webpack_public_path__ + "img/choose-archetype.0a9e0bea.svg";